"use client";

import Image from "next/image";
import { Heading, Text } from "@/components/ui/typography";

const testimonials = [
  {
    image: "/banking-setup/rectangle-30.webp",
    text: "I applied to two traditional Hong Kong banks before finding MuteTaxes. Both rejected my application. They guided me toward the right fintech option and helped prepare everything properly. My account was approved within weeks.",
    name: "Sophie Chhuon",
    role: "Founder, POASIA",
    avatar: "/banking-setup/rectangle-10.svg",
  },
  {
    image: "/banking-setup/rectangle-31.webp",
    text: "My company admin all managed in one place and I have one point of contact to make it super easy for me to manage it",
    name: "Sophie Chhuon",
    role: "Founder, POASIA",
    avatar: "/banking-setup/rectangle-10.svg",
  },
];

export default function FounderExperience({ heading = "Real Founder Experience" }: { heading?: string } = {}) {
  return (
    <section className="py-[60px] px-4">
      <div className="max-w-[1016px] mx-auto flex flex-col gap-[50px] items-center">

        {/* TITLE */}
        <Heading as="h2" variant="sectionCentered">
          {heading}
        </Heading>

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 w-full">
          {testimonials.map((item, i) => (
            <div
              key={i}
              className="bg-[#0f1218] border border-white/10 rounded-2xl p-6 flex flex-col gap-4 h-fit"
            >
              {/* IMAGE */}
              <div className="relative w-full h-[240px] md:h-[280px] lg:h-[313px]">
                <Image
                  src={item.image}
                  alt="testimonial"
                  fill
                  className="object-cover rounded-xl"
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <Image src={"/video-player.svg"} alt="player" width={48} height={48} className=""/>
                </div>
                
              </div>

              {/* CARD */}
              <div className="bg-[#161a22] border border-white/10 rounded-xl p-5 flex flex-col gap-[24px]">

                <Text variant="body" size="base">
                  {item.text}
                </Text>

                <div className="flex items-center justify-between gap-4">
                  <div className="flex md:gap-3 gap-1 flex-wrap">
                    <p className="font-suisse-intl text-white font-medium text-[18px] md:text-[20px]">
                      {item.name}
                    </p>
                    <Text variant="muted" muted={60} size="sm" as="p">
                      {item.role}
                    </Text>
                  </div>

                  <Image
                    src={item.avatar}
                    alt={item.name}
                    width={56}
                    height={56}
                    className="rounded-lg object-cover"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}